const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4 47V35H7M44 47V35H41M35 38V40M35 42V44M39 38V40M39 42V44M9 38V40M9 42V44M13 38V40M13 42V44M22 34V36M22 38V40M26 34V36M26 38V40M0 47H48M22 30V32M26 30V32M14 30V32M18 30V32M30 30V32M34 30V32M22 47V42H26V47H22Z",
  stroke: "#0073F7",
  strokeWidth: 2
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18 47V35H10V27H38V35H30V47",
  stroke: "#0073F7",
  strokeWidth: 2
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5 25C6.10457 25 7 24.1046 7 23C7 21.8954 6.10457 21 5 21C3.89543 21 3 21.8954 3 23C3 24.1046 3.89543 25 5 25Z",
  stroke: "#0073F7",
  strokeWidth: 2
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5 18V14V18ZM5 12V10V12ZM16 17H20C21.0609 17 22.0783 17.4214 22.8284 18.1716C23.5786 18.9217 24 19.9391 24 21V23H20C18.9391 23 17.9217 22.5786 17.1716 21.8284C16.4214 21.0783 16 20.0609 16 19V17ZM28 23H24V21C24 19.9391 24.4214 18.9217 25.1716 18.1716C25.9217 17.4214 26.9391 17 28 17H32V19C32 20.0609 31.5786 21.0783 30.8284 21.8284C30.0783 22.5786 29.0609 23 28 23ZM24 13V27V13ZM11 1H37V13H11V1Z",
  stroke: "#0073F7",
  strokeWidth: 2
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M24 10C25.6569 10 27 8.65685 27 7C27 5.34315 25.6569 4 24 4C22.3431 4 21 5.34315 21 7C21 8.65685 22.3431 10 24 10Z",
  stroke: "#0073F7",
  strokeWidth: 2
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M44 31C45.1046 31 46 30.1046 46 29C46 27.8954 45.1046 27 44 27C42.8954 27 42 27.8954 42 29C42 30.1046 42.8954 31 44 31Z",
  stroke: "#0073F7",
  strokeWidth: 2
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M44 18V16M44 24V20V24Z",
  stroke: "#0073F7",
  strokeWidth: 2
});
function SvgExperience(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience);
export default __webpack_public_path__ + "static/media/experience.42368df1.svg";
export { ForwardRef as ReactComponent };